export interface ClientResponseSI {
  affiliates: Affiliate[];
  affiliatesRut: string;
  affiliatesBusinessName: string;
  isAssociatedCompany: boolean;
  thisEconomicGroup: boolean;
  nameEnterprise: string;
  rutEnterprise: string;
}

export interface Affiliate {
    idAffiliates: string;
    rut?: string;
    dni?: string;
    businessName: string;
}

export interface ClientRequestSI {
  idProject: string;
  affiliatesRut: string;
  affiliatesBusinessName: string;
  isAssociatedCompany: boolean;
  thisEconomicGroup: boolean;
}

export interface TakerInterface {
  _id?: string;
  dni: string;
  username: string;
  completeName: string;
  economicGroupId: string;
}